<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.sites'), name: 'company_sites' },
            {
              text: area.site && area.site.name,
              name: 'site',
              params: { site_uuid: $route.params.site_uuid },
            },
            { text: area.name },
          ]"
        />
      </template>
    </SectionHeader>
    <div class="body-content">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" />
        <div v-else>
          <AreaForm :initialArea="area" :site="area.site" :zones="zones" @submit="updateArea" />
          <ZoneIndex :area="area" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AreaForm from '@/views/companies/sites/areas/AreaForm.vue'
import ZoneIndex from '@/views/companies/sites/areas/ZoneIndex.vue'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import areasApi from '@/api/areas'
import zonesApi from '@/api/zones'

export default {
  name: 'company_area',
  data: () => ({
    area: {},
    loading: true,
    zones: [],
  }),
  components: {
    AreaForm,
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    SectionHeader,
    ZoneIndex,
  },
  methods: {
    async updateArea(area) {
      this.area = await areasApi.update(area.site.uuid, area.uuid, area)
      await this.$router.push({ name: 'site', params: { site_uuid: area.site.uuid } })
    },
    async getData() {
      this.loading = true
      this.area = await areasApi.get(this.$route.params.site_uuid, this.$route.params.area_uuid)
      this.zones = await zonesApi.getAllInSite(this.$route.params.site_uuid)
      this.loading = false
    },
  },
  mounted() {
    this.getData()
  },
}
</script>
